import TourHighlight from "./TourHighlight";

export default TourHighlight;
